import { render } from "./DownloadLeaveReport.vue?vue&type=template&id=2a68f650"
import script from "./DownloadLeaveReport.vue?vue&type=script&lang=js"
export * from "./DownloadLeaveReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__